import React from 'react';
import { useField, useFormikContext, FormikValues } from 'formik';
import CheckIcon from 'mdi-react/CheckIcon';

interface Props {
  id: string;
  name: string;
  className?: string;
  value: string;
  text: string;
  disabled?: boolean;
  onChangeAction?: () => void;
}

const FormCheckboxGroupItem = (props: Props) => {
  const { id, name, text, value, className, disabled, onChangeAction } = props;
  const form = useFormikContext<FormikValues>();
  const [field] = useField<string[]>(name);

  const isChecked = field.value.includes(value);
  const CheckedLabelClass = isChecked ? 'checked' : '';

  const onFieldChange = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    form.setFieldTouched(name, true);
    if (field.value.includes(value)) {
      const nextValue = field.value.filter((val: string) => val !== value);
      form.setFieldValue(name, nextValue);
    } else {
      const nextValue = field.value.concat(value);
      form.setFieldValue(name, nextValue);
    }
    if (onChangeAction) {
      onChangeAction();
    }
  };

  return (
    <div role="presentation" onClick={onFieldChange}>
      <label
        className={`${className || ''} checkbox-btn${disabled ? ' disabled' : ''}`}
        htmlFor={id}
      >
        <input
          id={id}
          className="checkbox-btn__checkbox"
          type="checkbox"
          name={name}
          value={value}
          onChange={() => {}}
          checked={isChecked}
          disabled={disabled}
        />
        <span className="checkbox-btn__checkbox-custom">
          <CheckIcon />
        </span>
        <span className={`checkbox-btn__label ${CheckedLabelClass}`}>{text}</span>
      </label>
    </div>
  );
};

export default FormCheckboxGroupItem;
